import { get } from 'lodash';
import { createSelector } from 'reselect';

const getAuth = state => state.auth;

export const isAuthenticated = createSelector(getAuth, auth => get(auth, 'isAuthenticated'));
